export default {
  name: 'benefiting',
  component_path: 'modules/procedures/blocks/BlockBenefiting'
}